<template>
  <CFormGroup
    v-bind="{validFeedback, invalidFeedback, tooltipFeedback, description,
             wrapperClasses, class: computedClasses}"
    :style="wrapperAttrs.style"
    :class="wrapperAttrs.class"
  >
    <template #label>
      <slot name="label">
        <label v-if="label" :for="safeId" :class="labelClasses">
          {{label}}
        </label>
      </slot>
    </template>
    <template #input>
      <input
        v-bind="controlAttrs"
        :id="safeId"
        :class="inputClasses"
        :multiple="multiple"
        type="file"
        @change="onChange($event)"
      />
      <label v-if="custom" :for="safeId" class="custom-file-label">
        {{computedPlaceholder}}
      </label>
    </template>
    <template v-for="slot in passSlots" #[slot]>
      <slot :name="slot"></slot>
    </template>
  </CFormGroup>
</template>

<script>
import * as allFormMixins from './form-mixins'
import { inputFileProps as props } from './form-props'
import CFormGroup from './CFormGroup.vue'
const { sharedComputedProps, wrapperComputedProps, classesComputedProps } = allFormMixins

export default {
  name: 'CInputFile',
  inheritAttrs: false,
  components: { CFormGroup },
  mixins: [sharedComputedProps, wrapperComputedProps, classesComputedProps],
  props,
  emits: ['change'],
  data () {
    return { state: null }
  },
  computed: {
    passSlots () {
      return ['label-after-input', 'valid-feedback', 'invalid-feedback', 'description'].filter((s) => this.$slots[s])
    },
    computedPlaceholder () {
      return this.placeholder || `Choose file${this.multiple ? 's' : ''}...`
    },
    computedClasses () {
      return [
        this.isHorizontal ? 'form-row' : this.custom ? 'custom-file' : 'form-group position-relative',
        { 'was-validated': this.wasValidated }
      ]
    },
    inputClass () {
      return this.custom ? 'custom-file-input' : 'form-control-file'
    },
    haveInputGroup () {
      return false
    }
  },
  methods: {
    onChange (e) {
      this.state = e.target.files
      this.$emit('change', e.target.files, e)
    }
  }
}
</script>
